import { Injectable } from '@angular/core';
import { FullscreenViewAction } from './fullscreen-table.view-action';

@Injectable()
export class DisableFullscreenViewAction extends FullscreenViewAction {
  actionName: string = 'DISABLE_FULLSCREEN';

  onClick(context?: undefined): void {
    this.fullScreenService.setIsFullscreen(false);
  }
}
